import React from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';
import * as commonActions from '../../redux/actions/commonActions';

type Props = {
  common: any;
  dispatchCloseError: any;
};

const SuccesssDialog: React.FC<Props> = ({ common, dispatchCloseError }) => {
  return (
    <Dialog aria-labelledby="error-dialog" open={common.successsDialog}>
      <DialogTitle id="error-dialog">Success</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{common.successMsg}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={dispatchCloseError} color="primary" autoFocus>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state: any) => ({
  common: state.commonReducer,
});

const mapDispatchToProps = {
  dispatchCloseError: () => commonActions.closeSuccessDialog(),
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccesssDialog);
